import P from 'prop-types';
import React from 'react';
import AttendeeLogin from './reactViews/AttendeeLogin';
import { LoginWidgetScreen } from '@bizzabo/attendee-auth-api';
import BootstrapData from 'models/BootstrapData';
import url from 'url';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';

const me = BootstrapData('bootstrap-data-me');
const event = BootstrapData('bootstrap-data-event');

const isWidget = () => {
    const currentUrl = document.location.href;
    const currentUrlObj = url.parse(currentUrl, true);
    return currentUrlObj.query.widget === 'true';
};

const ReactEditProfileView = ({ groupId }) => {
    // Example: https://events.bizzabo.com/221896/settings/changeEmail?redirectUrl=https%3A%2F%2Fevents.bizzabo.com%2F221896%2Fsettings%2Fprofile&attendee=true&groupId=2&userId=14
    const handleChangeEmail = () => {
        const changeEmailUrl = getInternalWebsiteBaseUrl(
            event,
            url.format({
                pathname: '/settings/changeEmail',
                query: {
                    redirectUrl: window.location.href,
                    attendee: true,
                    groupId,
                    userId: me.id,
                    widget: isWidget(),
                },
            })
        );
        window.location.href = changeEmailUrl;
    };

    const handleProfileChange = profile => {
        console.log('onNotifyProfileChanged', profile);
        // this.model.set(profile);
        // this.model.set('joinedNow', true);
        // if (this.model.noJoin) {
        //     this.model.set({ isJoined: true });
        // }
        // this.trigger('back');
    };

    return (
        <div className="font-titillium">
            <h1 className="bz-header">Your Profile</h1>
            <AttendeeLogin
                inline
                showChangeEmail
                isShownByDefault
                closable={false}
                showTitle={false}
                screen={LoginWidgetScreen.profileFull}
                onNotifyChangeEmail={handleChangeEmail}
                onNotifyProfileChanged={handleProfileChange}
            />
        </div>
    );
};

ReactEditProfileView.propTypes = {
    groupId: P.number.isRequired,
};

export default ReactEditProfileView;
